
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface AllocationsHeaderProps {
  onAddClick: () => void;
}

export function AllocationsHeader({ onAddClick }: AllocationsHeaderProps) {
  return (
    <h2 className="text-xl font-semibold">Prize Allocations</h2>
  );
}
